export const missionRecoveryMessages = {
  "missions.recovery.coordinator": "Verify and recover coordinator",
  "missions.recovery.report": "Verify and recover missing report",
  "missions.recovery.pending": "Verifying recovery eligibility…",
  "missions.recovery.error.busy": "Native work or an unresolved wait prevents recovery. Open the conversation.",
  "missions.recovery.error.unknown": "Native activity could not be verified. Recovery was not admitted.",
  "missions.recovery.error.conflict": "The mission or recovery target changed. Refresh the mission before trying again.",
  "missions.recovery.error.failed": "Recovery admission could not be confirmed. Refresh the mission before trying again.",
}
